import { useContext } from 'react';
import { Row, Form, Col } from 'react-bootstrap';
import { CategoryContext } from '../../../../context/category';

export function ConfigProducts() {
  const {
    visible_falimix,
    setVisible_falimix,
    visible_autoplu,
    setVisible_autoplu,
    visible_delivery,
    setVisible_delivery,
    visible_xd_orders,
    setVisible_xd_orders,
    visible_online,
    setVisible_online,
    visible_digital_menu,
    setVisible_digital_menu,
  } = useContext(CategoryContext);

  return (
    <div>
      <Row className="px-2 mt-4 mx-4">
        <Col md="3">
          <Form.Switch
            label="Visível FAMIX"
            onChange={(e: any) => setVisible_falimix(e.target.checked)}
            checked={visible_falimix}
          />
        </Col>

        <Col md="3">
          <Form.Switch
            label="Visível AUTOPLU"
            onChange={(e: any) => setVisible_autoplu(e.target.checked)}
            checked={visible_autoplu}
          />
        </Col>

        <Col md="3">
          <Form.Switch
            label="Visível no Delivery"
            onChange={(e: any) => setVisible_delivery(e.target.checked)}
            checked={visible_delivery}
          />
        </Col>
      </Row>
      <Row className="px-2 mx-4">
        <Col md="3">
          <Form.Switch
            label="Visível no XD orders"
            onChange={(e: any) => setVisible_xd_orders(e.target.checked)}
            checked={visible_xd_orders}
          />
        </Col>

        <Col md="3">
          <Form.Switch
            label="Visível online"
            onChange={(e: any) => setVisible_online(e.target.checked)}
            checked={visible_online}
          />
        </Col>

        <Col md="3">
          <Form.Switch
            label="Visível no Menu Digital"
            onChange={(e: any) => setVisible_digital_menu(e.target.checked)}
            checked={visible_digital_menu}
          />
        </Col>
      </Row>
    </div>
  );
}
